import {
  SettingsFormatStaticTable,
  SettingsSizeOptions,
  SettingsStyleOptions,
  SmoothTypeEnum,
  TypeOptionsEnum,
} from '../../../utils/constants/selectOptions';
import { ScaleOptionsEnum } from '../regular-chart/constants';

interface TRegularTrackingTableState {
  settingsShowTitle: boolean;
  settingsShowRefreshButtons: boolean;
  settingsStyle: SettingsStyleOptions;
  settingsChartSize: SettingsSizeOptions;
  chartChartType: TypeOptionsEnum;
  chartLineWidth: 2 | 4 | 6 | 8;
  chartSmoothType: SmoothTypeEnum;
  settingsYaxisScale?: ScaleOptionsEnum;
  settingsMaximum: number;
  settingsMinimum: number;
  settingsFormat: SettingsFormatStaticTable;
  settingsWidgetControls: {
    objectSelect: boolean;
    intervalRange: boolean;
    aggregationFunctionSelect: boolean;
    csvButton: boolean;
    datePresets: boolean;
  };
}

export const FORM_DEFAULT_VALUES: TRegularTrackingTableState = {
  settingsStyle: SettingsStyleOptions.lightondark,
  settingsFormat: SettingsFormatStaticTable.table,
  settingsShowTitle: true,
  settingsShowRefreshButtons: false,
  settingsChartSize: SettingsSizeOptions.medium,
  chartChartType: TypeOptionsEnum.line,
  chartSmoothType: SmoothTypeEnum.smooth,
  settingsYaxisScale: ScaleOptionsEnum.auto,
  settingsMaximum: 0,
  settingsMinimum: 100,
  chartLineWidth: 2,
  settingsWidgetControls: {
    objectSelect: true,
    intervalRange: true,
    aggregationFunctionSelect: false,
    csvButton: false,
    datePresets: false,
  },
};
